import { render, staticRenderFns } from "./grouped-game-row.vue?vue&type=template&id=585213f3&scoped=true"
import script from "./grouped-game-row.vue?vue&type=script&lang=js"
export * from "./grouped-game-row.vue?vue&type=script&lang=js"
import style0 from "./grouped-game-row.vue?vue&type=style&index=0&id=585213f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585213f3",
  null
  
)

export default component.exports